import { render } from "./CargoTripScreen.vue?vue&type=template&id=3699eb34&scoped=true"
import script from "./CargoTripScreen.vue?vue&type=script&lang=js"
export * from "./CargoTripScreen.vue?vue&type=script&lang=js"

import "./CargoTripScreen.vue?vue&type=style&index=0&id=3699eb34&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3699eb34"]])

export default __exports__